// ** Third Party Components
import styled, { css } from "styled-components";

// ####################################################

export const StyledAttachmentContainer = styled("div")`
	position: relative;
	width: 120px;
	min-height: 90px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-right: auto;

	${({ $customMarginTop }) =>
		$customMarginTop &&
		css`
			margin-top: ${$customMarginTop};
		`};
`;

// ####################################################
